import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="overflow-y-scroll flex flex-col gap-3 font-poppins">
      <h3 className="text-heading3" id="introduction">
        Introduction
      </h3>
      <p className="text-normal">
        Brij Education Pte. Ltd. (“Brij”, “we” or “us”) takes the privacy of
        your information seriously. This Privacy Policy applies to the
        brijedu.com website (the “Website”) and governs data collection,
        processing and usage in compliance with the Personal Data Protection Act
        2012 (No. 26 of 2012) of Singapore (“PDPA”). By using the Website, you
        consent to the data practices described in this statement. Capitalized
        terms that are not defined in this Privacy Policy have the meaning given
        to them in our Terms of Service.
      </p>
      <h3
        className="text-heading3"
        id="information-collected-from-all-visitors-to-our-website"
      >
        Information Collected from All Visitors to our Website
      </h3>
      <p className="text-normal">
        We will obtain personal data about you when you visit us. When you visit
        us, we may monitor the use of this Website through the use of cookies
        and similar tracking devices. For example, we may monitor the number of
        times you visit our Website or which pages you go to. This information
        helps us to build a profile of our users. Some of this data will be
        aggregated or statistical, which means that we will not be able to
        identify you individually.
      </p>
      <p className="text-normal">
        This Privacy Policy applies to all visitors to our Website.
      </p>
      <h3
        className="text-heading3"
        id="additional-personal-information-that-may-be-collected"
      >
        Additional Personal Information that May be Collected
      </h3>
      <p className="text-normal">Brij may collect and process:</p>
      <ol>
        <li className="text-normal">
          Personally identifiable information, such as:
          <ol>
            <li className="text-normal">
              Your e-mail address and name, when you contact us;
            </li>
            <li className="text-normal">
              Details contained in the relevant document that you key in when
              you use our Services. These details may include your name,
              handphone number, email, the purpose of your query, and details
              about your will; (“Personal Information”)
            </li>
          </ol>
        </li>
        <li className="text-normal">
          Information about your computer hardware and software when you use our
          Website. The information can include: your IP address, browser type,
          domain names, access times and referring website addresses. This
          information is used by Brij for the operation of the Services, to
          maintain quality of the Services, and to provide general statistics
          regarding use of the brijedu.com Website.
        </li>
      </ol>
      <h3 className="text-heading3" id="use-of-personal-information">
        Use of Personal Information
      </h3>
      <p className="text-normal">Brij uses the collected information:</p>
      <ol>
        <li className="text-normal">
          To operate the Website and deliver the Services;
        </li>
        <li className="text-normal">
          To process, and where necessary, respond to your application, enquiry
          or request;
        </li>
        <li className="text-normal">To gather customer feedback;</li>
        <li className="text-normal">
          To inform or update you of other products or services available from
          Brij and its affiliates, where you have consented to be contacted for
          such purposes;
        </li>
        <li className="text-normal">
          To monitor, improve and administer the Website and Services, and to
          provide general statistics regarding user of the Website;
        </li>
        <li className="text-normal">
          To update you on changes to the Website and Services.
        </li>
      </ol>
      <h3 className="text-heading3" id="non-disclosure">
        Non-disclosure
      </h3>
      <p className="text-normal">
        Brij does not sell, rent, lease, or release your Personal Information to
        third parties. Brij may, from time to time, contact you on behalf of
        external business partners about a particular offering that may be of
        interest to you. In those cases, your unique Personal Information is not
        transferred to the third party without your explicit consent. In
        addition, Brij may share data with trusted partners to help us perform
        statistical analysis, send you email or provide customer support. All
        such third parties are prohibited from using your personal information
        except to provide these services to Brij, and they are required to
        maintain the confidentiality of your Personal Information.
      </p>
      <h3 className="text-heading3" id="disclosure-of-personal-information">
        Disclosure of Personal Information
      </h3>
      <p className="text-normal">
        Brij will disclose or share your Personal Information, without notice,
        only if required to do so by law or in the good faith belief that any
        such action is necessary to: (a) comply with any legal requirements or
        comply with legal process served on Brij or the Website; (b) protect and
        defend the rights or property of Brij; and (c) act under exigent
        circumstances to protect the personal safety of users of brijedu.com, or
        the general public.
      </p>
      <p className="text-normal">
        We may disclose your personal information to third parties: (a) in the
        event that we sell or buy any business or assets, in which case we may
        disclose your personal data to the prospective seller or buyer of such
        business or assets; and (b) if brijedu.com or substantially all of its
        assets are acquired by a third party, in which case personal data held
        by it about its customers will be one of the transferred assets.
      </p>
      <h3 className="text-heading3" id="use-of-cookies">
        Use Of Cookies
      </h3>
      <p className="text-normal">
        The Website uses “cookies” to help you personalize your online
        experience. A cookie is a text file that is placed on your hard drive by
        a web page server. Cookies cannot be used to run programs or deliver
        viruses to your computer. Cookies are uniquely assigned to you, and can
        only be read by a web server in the domain that issued the cookie to
        you.
      </p>
      <p className="text-normal">
        Cookies on the Website may be used to ensure a smooth user experience,
        perform analytics, and for showing relevant advertisements. Please note
        that third parties (such as analytics software) may also use cookies,
        over which we have no control. These cookies are likely to be
        analytical/performance cookies or targeting cookies. The Website uses
        Google Analytics. Please refer to{" "}
        <a href="http://www.google.com/policies/privacy/partners">
          http://www.google.com/policies/privacy/partners
        </a>{" "}
        to find out more about how Google uses data when you use our website and
        how to control the information sent to Google.
      </p>
      <p className="text-normal">
        Most Web browsers automatically accept cookies, but you can usually
        modify your browser setting to decline cookies if you prefer. If you
        choose to decline cookies, you may not be able to access all or parts of
        our Website or to fully experience the interactive features of the Brij
        services or websites you visit.
      </p>
      <h3 className="text-heading3" id="security-of-your-personal-information">
        Security Of Your Personal Information
      </h3>
      <p className="text-normal">
        We strive to maintain the safety of your Personal Information. Any
        payment transactions will be encrypted using SSL technology.
        Unfortunately, no internet-based service is completely secure. Although
        we will do our best to protect your personal data, we cannot guarantee
        the security of your data transmitted to our site; any transmission is
        at your own risk. Once we have received your information, we will use
        strict procedures and security features to try to prevent unauthorised
        access.
      </p>
      <h3
        className="text-heading3"
        id="access-to-updating-and-non-use-of-your-personal-information"
      >
        Access to, Updating, and Non-Use of Your Personal Information
      </h3>
      <p className="text-normal">
        Subject to the exceptions referred to in section 21(2) of PDPA, you have
        the right to request a copy of the information that we hold about you.
        If you would like a copy of some or all of your personal information,
        please send an email to support
        <a href="mailto:admin@brijedu.com">@brijedu.com</a>. We may make a small
        charge for this service.
      </p>
      <p className="text-normal">
        We want to ensure that your Personal Information is accurate and up to
        date. If any of the information that you have provided to Brij changes,
        for example if you change your email address, name or contact number,
        please let us know the correct details by sending an email to support
        <a href="mailto:admin@brijedu.com">@brijedu.com</a> You may ask us, or
        we may ask you, to correct information you or we think is inaccurate,
        and you may also ask us to remove information which is inaccurate.
      </p>
      <p className="text-normal">
        You have the right to ask us not to collect, use, process, or disclose
        your Personal Information in any of the manner described herein. We will
        usually inform you (before collecting your Personal Information) if we
        intend to use your Personal Information for such purposes or if we
        intend to disclose your Personal Information to any third party for such
        purposes. You can give us notice of your intention to halt the
        collection, use, processing, or disclosure of your Personal Information
        at any time by contacting us at support
        <a href="mailto:admin@brijedu.com">@brijedu.com</a>.
      </p>
      <h3 className="text-heading3" id="links-to-other-websites">
        Links to Other Websites
      </h3>
      <p className="text-normal">
        Our Website may contain links to other websites. This Privacy Policy
        only applies to this website so when you link to other websites you
        should read their own privacy policies.
      </p>
      <h3 className="text-heading3" id="changes-to-this-statement">
        Changes To This Statement
      </h3>
      <p className="text-normal">
        Brij will occasionally update this Privacy Policy to reflect customer
        feedback. Brij encourages you to periodically review this Privacy Policy
        to be informed of how Brij is protecting your information.
      </p>
      <h3 className="text-heading3" id="contact-information">
        Contact Information
      </h3>
      <p className="text-normal">
        Brij Education Pte. Ltd. welcomes your comments regarding this Privacy
        Policy. If you believe that brijedu.com has not adhered to this Privacy
        Policy, please contact us at support
        <a href="mailto:admin@brijedu.com">@brijedu.com</a>.
      </p>
    </div>
  );
}
